// R2'nin halka açık kökü. API yanıtından GELMİYOR: yükleme ekranı ilk API çağrısı çözülmeden
// boyanıyor, elimizde yalnızca alt alandan gelen slug var.
//
// Ezilebilir olması şart: `wrangler dev` tek bir localhost portu dinliyor, orada
// storage.noxussoft.com diye bir host yok — worker aynı nesneleri kendi portundan /storage yolunda
// veriyor (api/src/index.ts storagePathPrefix). Yerelde menu/.env.local içine:
//
//   VITE_STORAGE_URL=http://localhost:8787/storage
//
// Sabit kalsaydı yerelde yüklenen görsel canlıdaki adresle aranır ve 404 dönerdi.
export const STORAGE_URL =
  import.meta.env.VITE_STORAGE_URL ?? "https://storage.noxussoft.com";

// The tenant's loading-wave image, stored at a fixed slug-derived key.
export const loadingImageUrl = (slug) =>
  slug ? `${STORAGE_URL}/loading/${encodeURIComponent(slug)}.png` : null;

// Görseli olmayan kayıtlar için sabit yedek banner'lar; kovada `default/` altında duruyorlar.
// Buraya taşındılar çünkü iki ayrı sayfada elle yazılmışlardı ve STORAGE_URL değişince geride
// kalıyorlardı.
export const DEFAULT_BRANCH_IMAGE = `${STORAGE_URL}/default/branch.jpg`;
export const DEFAULT_CATEGORY_IMAGE = `${STORAGE_URL}/default/category-banner.jpg`;
